const firebaseConfig = {
    apiKey: 'AIzaSyCugim6rAoZn28AMS1znsjvGiyzJ8dNBq8',
    authDomain: 'tourism-website-client-36bf6.firebaseapp.com',
    projectId: 'tourism-website-client-36bf6',
    storageBucket: 'tourism-website-client-36bf6.appspot.com',
    messagingSenderId: '492505404042',
    appId: '1:492505404042:web:4c7c8eb8102e5209495373',
};

export default firebaseConfig;
